document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((item) => {
    const header = item.querySelector(".accordion-header");
    const body = item.querySelector(".accordion-body");

    if (body.classList.contains("d-none")) {
      body.classList.add("d-none");
      body.classList.remove("d-block");
    }

    header.addEventListener("click", function () {
      if (body.classList.contains("d-none")) {
        body.classList.remove("d-none");
        body.classList.add("d-block");
        header.classList.add("icon-rotate"); // Add rotation class when visible
      } else {
        body.classList.remove("d-block");
        body.classList.add("d-none");
        header.classList.remove("icon-rotate"); // Remove rotation class when hidden
      }
    });
  });
});
